(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifLogo', swifLogo);


    /**
    * @ngdoc directive
    * @name swif.ui:swifLogo
    * @module swif.ui
    * @restrict A
    * @description display background image from the settings
    **/
    function swifLogo($rootScope, $location, settingsService) {
        'ngInject';
        var settings = settingsService;
        return {
            restrict: 'E',
            replace: true,
            link: function (scope, element) {
                var medias = settings.app.medias || settings.app.defaultValues.medias;
                if (medias) {
                    if (medias.cityLogo) {
                        element.attr('src', medias.cityLogo);
                    } else {
                        element.remove();
                    }
                }
                function toggleLogo() {
                    if ($location.path() === '/login') {
                        setTimeout(function () {
                            $('.navbar-logo').hide();
                        }, 100);
                    } else {
                        $('.navbar-logo').show();
                    }
                }
                toggleLogo();
                $rootScope.$on('$routeChangeSuccess', function(event, currRoute, prevRoute){
                    toggleLogo();
                });

            },
            template:'<img class="img-thumbnail" alt="Logo">'
        };
    }

})();
